import OnboardingLayout from './onboarding-layout';

export default OnboardingLayout;
